export const SAFETY_QUESTIONNAIRE_CONTENTS = [
  {
    title: "Sicherheitsunterweisung: Bildschirm - Teil 1",
    videoTitle: "Video_Bildschirm_2",
    embeddingLink:
      "https://btbgmbh658.sharepoint.com/sites/btb.mail/_layouts/15/embed.aspx?UniqueId=1b4e5bdc-de68-4e37-a157-1284bb50cafc&embed=%7B%22hvm%22%3Atrue%2C%22ust%22%3Atrue%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create",
    questions: [
      {
        question:
          "Was wird als Beispiel dafür genannt, dich selbst zum Aufstehen zu bewegen?",
        answers: [
          {
            text: "Viel trinken, um oft auf Toilette gehen zu müssen",
            id: 0,
          },
          {
            text: "Den Locher so weit weg vom Schreibtisch platzieren, dass man zum Aufstehen gezwungen wird",
            id: 1,
          },
          {
            text: "Einen Timer stellen, der dich regelmäßig zu 5-Minütigen Gymnastik-Übungen motiviert",
            id: 2,
          },
          {
            text: "Regelmäßig an Nerf-Gun-Wars im Büro teilnehmen",
            id: 3,
          },
        ],
        correct: 1,
      },
      {
        question:
          "Was ist bei der Einstellung der Höhe des Bürostuhls zu beachten?",
        answers: [
          {
            text: "Die Augen sind ungefähr auf Höhe der Oberkante des Bildschirms",
            id: 0,
          },
          {
            text: "Der bewegliche Bürostuhl soll sich auf einer rutschfesten Unterlage befinden",
            id: 1,
          },
          {
            text: "Bürostühle müssen verschiedene Sitzpositionen (z.B. Schneidersitz) zulassen",
            id: 2,
          },
          {
            text: "Bürostühle müssen vom TÜV für Büro-interne Bürostuhlrennen abgenommen sein",
            id: 3,
          },
        ],
        correct: 0,
      },
    ],
  },
  {
    title: "Sicherheitsunterweisung: Bildschirm - Teil 2",
    videoTitle: "Video_Bildschirm_3",
    embeddingLink:
      "https://btbgmbh658.sharepoint.com/sites/btb.mail/_layouts/15/embed.aspx?UniqueId=36f451be-632d-467a-a0ab-78ddd594626f&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create",
    questions: [
      {
        question: "Was soll wörtlich mit beschädigten Kabeln geschehen?",
        answers: [
          {
            text: "Das Kabel wird aus dem Verkehr gezogen",
            id: 0,
          },
          {
            text: "Das Kabel wird vernichtet",
            id: 1,
          },
          {
            text: "Das Kabel wird ersetzt",
            id: 2,
          },
          {
            text: "Das Kabel wird mittels eines Stücks nicht-leitender Rinderhaut isoliert",
            id: 3,
          },
        ],
        correct: 0,
      },
      {
        question: "Was sollte bezüglich Pausen beachtet werden?",
        answers: [
          {
            text: "Der Arbeitsplatz darf aus versicherungstechnischen Gründen auch in der Pause nicht verlassen werden",
            id: 0,
          },
          {
            text: "Pausen sollten einmal stündlich stattfinden",
            id: 1,
          },
          {
            text: "Es sollte in Pausen möglichst nicht über die Arbeit gesprochen werden",
            id: 2,
          },
          {
            text: "Pausen sind als Arbeitszeit abzurechnen - und zwar doppelt",
            id: 3,
          },
        ],
        correct: 2,
      },
    ],
  },
  {
    title: "Sicherheitsunterweisung: Brandschutz",
    videoTitle: "Video_Brandschutz",
    embeddingLink:
      "https://btbgmbh658.sharepoint.com/sites/btb.mail/_layouts/15/embed.aspx?UniqueId=98051871-0009-4a71-9a06-686cb912e429&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create",
    questions: [
      {
        question: "Im Video ist echtes Feuer zu sehen. Wo ist heißes Feuer?",
        answers: [
          {
            text: "In einem Kamin",
            id: 0,
          },
          {
            text: "In einem Eimer",
            id: 1,
          },
          {
            text: "In einer Pfanne",
            id: 2,
          },
          {
            text: "Zwischen den beiden Protagonisten",
            id: 3,
          },
        ],
        correct: 1,
      },
      {
        question:
          "Dringt Rauch in den Raum ein, womit sollte der Eintrittsort am besten abgedichtet werden?",
        answers: [
          {
            text: "Mit feuchten Tüchern",
            id: 0,
          },
          {
            text: "Mit dicker, luftundurchlässiger Kleidung",
            id: 1,
          },
          {
            text: "Mit Löschschaum aus dem Feuerlöscher",
            id: 2,
          },
          {
            text: "Mit FFP-2 Masken",
            id: 3,
          },
        ],
        correct: 0,
      },
    ],
  },
  {
    title: "Sicherheitsunterweisung: Elektrische Geräte",
    videoTitle: "Video_elektrische_Geraete_2",
    embeddingLink:
      "https://btbgmbh658.sharepoint.com/sites/btb.mail/_layouts/15/embed.aspx?UniqueId=5268bca1-2983-464a-9949-fb6b1d9c1e24&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create",
    questions: [
      {
        question:
          "Welche der folgenden Punkte wird nicht als Auswirkungen eines Störlichtbogens auf den menschlichen Körper genannt?",
        answers: [
          {
            text: "Akustische Auswirkungen",
            id: 0,
          },
          {
            text: "Körperdurchströmung",
            id: 1,
          },
          {
            text: "Thermische Auswirkungen",
            id: 2,
          },
          {
            text: "Emotionaler Schock",
            id: 3,
          },
        ],
        correct: 3,
      },
      {
        question:
          "Welche der folgenden Sekundärunfälle bei Unfällen mit Strom wird im Video genannt?",
        answers: [
          {
            text: "Schürfwunden",
            id: 0,
          },
          {
            text: "Schnitte",
            id: 1,
          },
          {
            text: "Unterkühlung",
            id: 2,
          },
          {
            text: "Ungewollte Schwangerschaft",
            id: 3,
          },
        ],
        correct: 1,
      },
    ],
  },
  {
    title: "Sicherheitsunterweisung: Erste Hilfe - Teil 1",
    videoTitle: "Video_Erste_Hilfe_1",
    embeddingLink:
      "https://btbgmbh658.sharepoint.com/sites/btb.mail/_layouts/15/embed.aspx?UniqueId=50c30f7d-b62a-4cee-aa43-ced87f26eb56&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create",
    questions: [
      {
        question: "Worauf sollte man als erstes bei erster Hilfe achten?",
        answers: [
          {
            text: "Gesamtsituation beurteilen, um sich selbst nicht in Gefahr zu bringen",
            id: 0,
          },
          {
            text: "Den Notruf wählen",
            id: 1,
          },
          {
            text: "Beatmen, falls nötig",
            id: 2,
          },
          {
            text: "Den Unfallhergang auf Instagram dokumentieren",
            id: 3,
          },
        ],
        correct: 0,
      },
      {
        question:
          "Was sagt das Video dazu, Verletzte eigenhändig ins Krankenhaus zu transportieren?",
        answers: [
          {
            text: "Dies darf niemals unternommen werden",
            id: 0,
          },
          {
            text: "Dies soll nur bei augenscheinlich leichten Verletzungen unternommen werden",
            id: 1,
          },
          {
            text: "Dies soll nach Möglichkeit immer unternommen werden",
            id: 2,
          },
          {
            text: "Nur Kinder müssen ins Krankenhaus. Eine Mütze Schlaf reicht ja wohl",
            id: 3,
          },
        ],
        correct: 0,
      },
    ],
  },
  {
    title: "Sicherheitsunterweisung: Erste Hilfe - Teil 2",
    videoTitle: "Video_Erste_Hilfe_2",
    embeddingLink:
      "https://btbgmbh658.sharepoint.com/sites/btb.mail/_layouts/15/embed.aspx?UniqueId=873f0ec0-2a04-4dbe-8cd5-358e4e47e9ca&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create",
    questions: [
      {
        question:
          "Wie heißt das Dokument, in dem Erste-Hilfe-Maßnahmen dokumentiert werden müssen?",
        answers: [
          {
            text: "Gipsbuch",
            id: 0,
          },
          {
            text: "Pflasterbuch",
            id: 1,
          },
          {
            text: "Verbandbuch",
            id: 2,
          },
          {
            text: "Buchbuch",
            id: 3,
          },
        ],
        correct: 2,
      },
      {
        question:
          "Wann wird erklärt, wie man einen Laien-Defibrillator benutzt?",
        answers: [
          {
            text: "In der zweiten Videohälfte",
            id: 0,
          },
          {
            text: "In der ersten Videohälfte",
            id: 1,
          },
          {
            text: "Durch den Defibrillator selbst - bei seiner Nutzung",
            id: 2,
          },
          {
            text: "Googlen hilft eigentlich immer",
            id: 3,
          },
        ],
        correct: 2,
      },
    ],
  },
  {
    title: "Sicherheitsunterweisung: Fuhrpark - Teil 1",
    videoTitle: "Video_Fuhrpark_1",
    embeddingLink:
      "https://btbgmbh658.sharepoint.com/sites/btb.mail/_layouts/15/embed.aspx?UniqueId=751f8cde-dc56-4f9c-9e98-158b59ef4f54&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create",
    questions: [
      {
        question:
          "Das Video beschreibt, dass die Nutzung des Bordcomputers gefährlich ablenkend sein kann. Welche Automarke fährt der Protagonist in diesem Videoausschnitt?",
        answers: [
          {
            text: "Audi",
            id: 0,
          },
          {
            text: "VW",
            id: 1,
          },
          {
            text: "Opel",
            id: 2,
          },
          {
            text: "Bobbycar",
            id: 3,
          },
        ],
        correct: 0,
      },
      {
        question:
          "Wie viel Prozent der Arbeits-relevanten Unfälle entstehen laut der DGUV im Straßenverkehr?",
        answers: [
          {
            text: "61%",
            id: 0,
          },
          {
            text: "59%",
            id: 1,
          },
          {
            text: "60%",
            id: 2,
          },
          {
            text: "62%",
            id: 3,
          },
        ],
        correct: 3,
      },
    ],
  },
  {
    title: "Sicherheitsunterweisung: Fuhrpark - Teil 2",
    videoTitle: "Video_Fuhrpark_2",
    embeddingLink:
      "https://btbgmbh658.sharepoint.com/sites/btb.mail/_layouts/15/embed.aspx?UniqueId=50d60121-d346-4fbc-b2ce-4782a14ff0e3&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create",
    questions: [
      {
        question: "Welche der folgenden Empfehlungen wird nicht genannt?",
        answers: [
          {
            text: "Am Steuer keine SMS senden",
            id: 0,
          },
          {
            text: "Regelmäßig den Ölstand überprüfen",
            id: 1,
          },
          {
            text: "Auf die korrekte Bereifung (Winter/Sommer) achten",
            id: 2,
          },
          {
            text: "Rauchen am Steuer",
            id: 3,
          },
        ],
        correct: 3,
      },
      {
        question:
          "Wie wird im Video wird 'aggressives Fahrverhalten' visualisiert?",
        answers: [
          {
            text: "Der Fahrer klopft wütend auf das Lenkrad",
            id: 0,
          },
          {
            text: "Der Fahrer zeigt seinen Mitfahrern 'den Vogel'",
            id: 1,
          },
          {
            text: "Der Fahrer fährt offensichtlich zu nah auf",
            id: 2,
          },
          {
            text: "Der Fahrer überholt rechts",
            id: 3,
          },
        ],
        correct: 0,
      },
    ],
  },
  {
    title: "Sicherheitsunterweisung: Fuhrpark - Teil 3",
    videoTitle: "Video_Fuhrpark_4",
    embeddingLink:
      "https://btbgmbh658.sharepoint.com/sites/btb.mail/_layouts/15/embed.aspx?UniqueId=797bf6e6-0346-4def-ba1a-04b4f3930204&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create",
    questions: [
      {
        question: "Welche Farbe hat die Notrufsäule im Video?",
        answers: [
          {
            text: "Grün",
            id: 0,
          },
          {
            text: "Rot",
            id: 1,
          },
          {
            text: "Orange",
            id: 2,
          },
          {
            text: "#455478",
            id: 3,
          },
        ],
        correct: 2,
      },
      {
        question:
          "Muss die Polizei bei einem Unfall mit einem Dienstfahrzeug hinzugezogen werden?",
        answers: [
          {
            text: "Nur bei Unfällen mit Personenschaden",
            id: 0,
          },
          {
            text: "Nur, wenn nach Rücksprache mit dem Arbeitgeber so entschieden",
            id: 1,
          },
          {
            text: "Ja, immer",
            id: 2,
          },
          {
            text: "Mit der Polizei wird ausschließlich am ersten Mai interagiert",
            id: 3,
          },
        ],
        correct: 2,
      },
    ],
  },
  {
    title: "Sicherheitsunterweisung: Praxistipps",
    videoTitle: "Video_Praxistipps",
    embeddingLink:
      "https://btbgmbh658.sharepoint.com/sites/btb.mail/_layouts/15/embed.aspx?UniqueId=17f66fd6-082f-4e76-9375-1ff6e633dedc&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create",
    questions: [
      {
        question:
          "Wenn eine Person brennt und mittels Feuerlöscher gelöscht wird, was ist zu beachten?",
        answers: [
          {
            text: "Möglichst von den Beinen zum Kopf löschen",
            id: 0,
          },
          {
            text: "CO₂-Feuerlöscher können zu Kälteverbrennungen führen",
            id: 1,
          },
          {
            text: "Die Person nach der Löschung mit Decken isolieren",
            id: 2,
          },
          {
            text: "Unnötig verbrauchte Feuerlöscher werden einem bei der BTB vom Gehalt abgezogen",
            id: 3,
          },
        ],
        correct: 1,
      },
      {
        question:
          "Kleinere Verletzungen sollten gekühlt werden. Wie sollte dies im Idealfall geschehen?",
        answers: [
          {
            text: "Unter fließend kaltem Wasser",
            id: 0,
          },
          {
            text: "Mittels in Speiseöl getränkten Tüchern",
            id: 1,
          },
          {
            text: "Mittels Kühl-Packs aus der Gefriertruhe",
            id: 2,
          },
          {
            text: "Pro 10cm² verbrannter Hautfläche ist ein frisch kühlgestelltes Bier zu exen",
            id: 3,
          },
        ],
        correct: 0,
      },
    ],
  },
  {
    title: "Sicherheitsunterweisung: Hygiene",
    videoTitle: "Video_Unterweisung_Hygiene_1",
    embeddingLink:
      "https://btbgmbh658.sharepoint.com/sites/btb.mail/_layouts/15/embed.aspx?UniqueId=b3555914-dbe0-4f13-9359-7f0a71595bd3&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create",
    questions: [
      {
        question:
          "Welche der folgenden Geräte werden nicht als Beispiel dafür genannt, dass man gemeinsame Arbeitsmaterialien regelmäßig reinigen sollte?",
        answers: [
          {
            text: "Mikrowelle",
            id: 0,
          },
          {
            text: "Türklinken",
            id: 1,
          },
          {
            text: "Maus & Tastatur",
            id: 2,
          },
          {
            text: "Kühlschrank",
            id: 3,
          },
        ],
        correct: 1,
      },
      {
        question:
          "Nach einer Studie des Bundesamts für gesundheitliche Aufklärung - was gaben Männer deutlich häufiger an als Frauen?",
        answers: [
          {
            text: "Nicht ordnungsgemäß in den Ellenbogen zu niesen",
            id: 0,
          },
          {
            text: "Am Arbeitsplatz nicht die Zähne zu putzen",
            id: 1,
          },
          {
            text: "Sich nicht die Hände zu waschen",
            id: 2,
          },
          {
            text: "Dass die Gender-Pay-Gap überhaupt kein Problem darstellt",
            id: 3,
          },
        ],
        correct: 2,
      },
    ],
  },
];

export const PRIVACY_QUESTIONNAIRE_CONTENTS = {
  title: "Unterweisung - DSGVO",
  videoTitle: "Unterweisung_DSGVO",
  embeddingLink:
    "https://btbgmbh658.sharepoint.com/:v:/r/sites/btb.mail/_layouts/15/stream.aspx?id=%2Fsites%2Fbtb.mail%2FFreigegebene%20Dokumente%2FDatenschutz%20Infos%2FGrundlagen%20Datenschutz%20-%20Video%2FUnterweisung_DSGVO.mp4&nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJTdHJlYW1XZWJBcHAiLCJyZWZlcnJhbFZpZXciOiJTaGFyZURpYWxvZy1MaW5rIiwicmVmZXJyYWxBcHBQbGF0Zm9ybSI6IldlYiIsInJlZmVycmFsTW9kZSI6InZpZXcifX0%3D&share=cQpF6Z0cjROCQpOgMF1o5DdyEgUC3PoKegIBpmh9hObmFnYsSw",
  questions: [
    {
      question:
        "Bei der Definition von 'Personenbezogenen Daten' wird ein Attribut von 'Person' genannt, welches als wichtig zu erachten ist. Welches?",
      answers: [
        {
          text: "Personenbezogene Daten beziehen sich auf 'natürliche' Personen.",
          id: 0,
        },
        {
          text: "Personenbezogene Daten beziehen sich auf Personen mit 'deutscher Staatsbürgerschaft'.",
          id: 1,
        },
        {
          text: "Personenbezogene Daten beziehen sich auf Personen im 'juristischen' Sinne.",
          id: 2,
        },
        {
          text: "Personenbezogene Daten beziehen sich auf 'besonders niedliche' Personen.",
          id: 3,
        },
      ],
      correct: 0,
    },
    {
      question:
        "Welche Art von Datenverarbeitung gibt es nach der im Video genannten Definition nicht?",
      answers: [
        {
          text: "Erheben.",
          id: 0,
        },
        {
          text: "Verarbeiten.",
          id: 1,
        },
        {
          text: "Nutzen.",
          id: 2,
        },
        {
          text: "Anonymisieren.",
          id: 3,
        },
      ],
      correct: 3,
    },
    {
      question:
        "Welches Beispiel wird (über die Tonspur) als typisches Beispiel für familiäre Datenverarbeitung genannt?",
      answers: [
        {
          text: "Schulnoten.",
          id: 0,
        },
        {
          text: "Stammbaumpflege.",
          id: 1,
        },
        {
          text: "Genomsequenzierung.",
          id: 2,
        },
        {
          text: "Geburtstagskalender.",
          id: 3,
        },
      ],
      correct: 0,
    },
    {
      question:
        "Wenn jemand Widerspruch bezüglich der Verarbeitung seiner persönlichen Daten einlegt, wann ist dieser Widerspruch unwirksam.",
      answers: [
        {
          text: "Wenn die personenbezogenen Daten dem Geschäftszweck dienen.",
          id: 0,
        },
        {
          text: "Wenn die personenbezogenen Daten technisch nicht löschbar sind.",
          id: 1,
        },
        {
          text: "Wenn der Widerspruch nicht innerhalb von 2 Jahren gemacht wurde.",
          id: 2,
        },
        {
          text: "Wenn die BTB wirklich keinen Bock hat.",
          id: 3,
        },
      ],
      correct: 0,
    },
  ],
};
